<template>
    <div class="container-fluid" id="dvconfig">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaconfiguracao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnrillpayconfig" class="card">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaconfiguracao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item" @click.prevent="mtdcarregadadosfinanceiro()">
                                        <a class="nav-link active" id="tabfinanceiro" data-toggle="tab" href="#dvfinanceiro" role="tab" aria-controls="Financeiro" aria-selected="false"><i class="fa fa-money" aria-hidden="true"></i> Financeiro</a>
                                    </li>
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" id="dvconteudotab" style="padding-top: 15px; padding-bottom: 15px;">                                                                   
                                    <div class="tab-pane fade container-fluid fade show active" id="dvfinanceiro" role="tabpanel" aria-labelledby="financeiro-tab">
                                        <div class="row mt-4 pt-2">
                                            <div class="col-md-12">
                                                <h5 style="font-weight: 500; font-size: 18px;"><i class="fa fa-credit-card" aria-hidden="true"></i> Métodos de pagamento disponíveis</h5>
                                                <hr>
                                            </div>
                                            <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarpix()" type="checkbox" class="custom-control-input" id="swformapixinput" v-model="swformapix" name="swformapixinput">
                                                    <label class="custom-control-label" for="swformapixinput">
                                                        Pix
                                                        <span v-if="vformapix" class="badge badge-primary ml-3" style="background-color: green;">Ativo</span>
                                                        <span v-else class="badge badge-danger ml-3">Inativo</span>
                                                    </label>
                                                </div>
                                                <div class="row">
                                                    <div class="col">
                                                        <div class="collapse" id="dadosFormaPix">
                                                            <div class="card card-body mt-2" style="background-color: #f2f2f2;">
                                                                <div class="row">
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbidformapix">*Forma de pagamento:</label>
                                                                        <select id="cbidformapix" v-model="vidformapix"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                                                        <label for="cbcontapix">*Conta bancária:</label>
                                                                        <select id="cbcontapix" v-model="vidcontapix"
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-3 col-lg-3">
                                                                        <label for="edchavepix" style="width: 100%;">
                                                                            Chave Pix Beneficiário:
                                                                            <span class="badge badge-info" style="float: right;">{{ vtipochavepixpix }}</span>
                                                                        </label>
                                                                        <input type="text" class="form-control form-control-sm" id="edchavepix" v-model="vchavepixpix"
                                                                        disabled style="background-color: #fff;" @mouseover="showMsgPix = 1" @mouseleave="showMsgPix = 0"/>
                                                                        <transition name="fade">
                                                                            <div v-if="showMsgPix" class="tooltip-message">
                                                                                Chave pix definida no cadastro de contas bancárias.
                                                                            </div>
                                                                        </transition>
                                                                    </div>
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <label for="cbperfilfluxopix">Perfil fluxo:</label>
                                                                        <select id="cbperfilfluxopix" v-model="vidperfilfluxopix" 
                                                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                                                style="width:100%;">
                                                                        </select>
                                                                    </div>      
                                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                                        <button v-if="!vformapix" @click.prevent="mtdconfirmaalteracaopix('habilitar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Habilitar
                                                                        </button>
                                                                        <button v-if="vformapix" @click.prevent="mtdconfirmaalteracaopix('alterar')" class="btn btn-success btn-sm btn-definirtema">
                                                                            <i class="fa fa-check" aria-hidden="true"></i> Aplicar alterações
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <hr>
                                            </div>
                                            <!-- <div class="col-md-12">
                                                <div class="custom-control custom-switch">
                                                    <input @click="mtdconfirmadesabilitarcartaocred()" type="checkbox" class="custom-control-input" id="swformacartaocredinput" v-model="swformacartaocred" name="swformacartaocredinput">
                                                    <label class="custom-control-label" for="swformacartaocredinput">
                                                        Cartão de Crédito (EM BREVE)
                                                        <span class="badge badge-danger ml-3">Inativo</span>
                                                    </label>
                                                </div>
                                                <hr>
                                            </div> -->
                                        </div>
                                    </div>                                                                 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import util from '../utilitarios/util.js'

    export default {
        name: 'rillpayconfig',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                idfilialselecionada         : null,
                pfiltro                     : 1,
                pconteudo                   : '',
                pativo                      : 2,
                pqtdregistros               : 10,
                pqtd_paginas                : 1,
                pagina_atual                : 1,
                pqtd_total_registros        : 0,

                //variável para habilitação dos campos

                //variável p/ clonar configs filial
                //sem uso ainda
                vcodfilcopiarconfig         : null,
                
                // pix
                swformapix                  : false,
                vformapix                   : false,
                showMsgPix                  : 0,
                vidformapix                 : null,
                vidcontapix                 : null,
                vtipochavepixpix            : '',
                vchavepixpix                : '',
                vidperfilfluxopix           : null,



                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },

                itensbc : {
                    item1 : {
                        titulo : 'FILIAIS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : 'CONFIGURAÇÕES RILLPAY',
                        ativo  : true
                    }
                },

                columns: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoess",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "slot_id",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Título do destaque",
                        name: "descricao",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "slot_titulo",
                        row_classes: "def-col-titulo",
                    },
                    {
                        label: "Exibição do destaque",
                        name: "ativo",
                        slot_name: "slot_ativo",
                        row_classes: "def-col-ativo",
                    },
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            formatarCNPJ(cnpj){
                return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
            },
            formatarCPF(cpf){
                return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
            },
            formatarCelular(celular){
                return celular.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
            },
            mtdcancelaconfiguracao(){
                this.$router.go(-1);
            },
            mtdselect2_def(){
				let vself = this;

                $("#cbidformapix").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbformaspagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidformapix = $("#cbidformapix").val();
                });

                $("#cbcontapix").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcontasbancarias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidcontapix = $("#cbcontapix").val();
                });

                $("#cbperfilfluxopix").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbperfisfluxocaixa',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidperfilfluxopix = $("#cbperfilfluxopix").val();                    
                });
			},
            mtdcarregadadosfinanceiro(){
                var vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',               valor : 'carregadadosfinanceiros'},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial',         valor : vself.idfilialselecionada},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrillpayconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    // carrega dados do método pix, se tiver
                    if(Object.keys(response.data.formaspag.pix).length > 0) {
                        vself.vformapix         = response.data.formaspag.pix.ativo == 1 ? true : false;
                        vself.swformapix        = vself.vformapix
                        vself.vtipochavepixpix  = response.data.formaspag.pix.tpchavepix;

                        if (vself.vtipochavepixpix == 0) {
                            vself.vtipochavepixpix = 'Chave CNPJ';
                            vself.vchavepixpix = vself.formatarCNPJ(response.data.formaspag.pix.chavepix);
                        } else if (vself.vtipochavepixpix == 1) {
                            vself.vtipochavepixpix = 'Chave CPF';
                            vself.vchavepixpix = vself.formatarCPF(response.data.formaspag.pix.chavepix);
                        } else if (vself.vtipochavepixpix == 2) {
                            vself.vtipochavepixpix = 'Chave Celular';
                            vself.vchavepixpix = vself.formatarCelular(response.data.formaspag.pix.chavepix);
                        } else if (vself.vtipochavepixpix == 3) {
                            vself.vtipochavepixpix = 'Chave Aleatória';
                            vself.vchavepixpix = response.data.formaspag.pix.chavepix.toLowerCase();
                        } else {
                            vself.vtipochavepixpix = '';
                            vself.vchavepixpix = '';
                        }

                        vself.vtipochavepixpix = vself.vchavepixpix == '' ? '' : vself.vtipochavepixpix; // Correção para não exibir tipo de chave se não houver chave

                        vself.vidformapix       = response.data.formaspag.pix.idforma;
                        vself.vidcontapix       = response.data.formaspag.pix.idconta;
    
                        var defformapix = new Option(response.data.formaspag.pix.descforma, vself.vidformapix, true, true);
                        $('#cbidformapix').append(defformapix).trigger('change');
                        var defcontapix = new Option(response.data.formaspag.pix.descconta, vself.vidcontapix, true, true);
                        $('#cbcontapix').append(defcontapix).trigger('change');
                        if (response.data.formaspag.pix.idperfilfluxo > 0){
                            var defperfilfluxopix = new Option(response.data.formaspag.pix.descperfilfluxo, response.data.formaspag.pix.idperfilfluxo, true, true);
                            $('#cbperfilfluxopix').append(defperfilfluxopix).trigger('change');
                        }
                    } else {
                        vself.vformapix         = false;
                        vself.swformapix        = vself.vformapix;
                        vself.vtipochavepixpix  = '';
                        vself.vchavepixpix      = '';
                        vself.vidformapix       = null;
                        vself.vidcontapix       = null;
                        vself.vidperfilfluxopix = null;
                    }
                    console.log(response.data);
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            },
            mtdconfirmaalteracaopix(msg){
                let vself = this;
                $.confirm({
                    title: 'Confirmação!',
                    content: `Deseja ${msg} o método de pagamento pix?`,
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,                        
                    buttons: {
                        sim: {
                            text : '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                vself.mtdhabilitarmetodopix();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                return
                            }
                        }
                    }
                });
            },
            mtdhabilitarmetodopix(){
                if (this.vidformapix === null){
                    this.$toastr.w('Selecione a forma de pagamento!', 'Atenção!');
                    return;
                }
                if (this.vidcontapix === null){
                    this.$toastr.w('Selecione a conta bancária!', 'Atenção!');
                    return;
                }
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idforma'       : vself.vidformapix,
                    'idconta'       : vself.vidcontapix,
                    'ativo'         : 1,
                    'idperfilfluxo' : vself.vidperfilfluxopix,
                }
                let parametros = [
                    {parametro: 'op'                    , valor: 'crudmetodopix'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'registrocrud'          , valor: JSON.stringify(registrocrud)},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrillpayconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método de pagamento pix habilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
            mtdconfirmadesabilitarpix(){
                let vself = this;
                if (vself.swformapix && vself.vformapix) {
                    
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja desabilitar o método de pagamento pix?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'red',
                        typeAnimated: true,                        
                        buttons: {
                            sim: {
                                text : '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-red',
                                action: function () {
                                    vself.mtddesabilitarmetodopix();
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: function () {
                                    vself.mtdcarregadadosfinanceiro();
                                    return
                                }
                            }
                        }
                    });
                }
            },
            mtddesabilitarmetodopix(){
                let vself = this;
                let loader = vself.$loading.show();
                let registrocrud = {
                    'idforma'       : vself.vidformapix,
                    'idconta'       : vself.vidcontapix,
                    'ativo'         : 0,
                    'idperfilfluxo' : vself.vidperfilfluxopix,
                }
                let parametros = [
                    {parametro: 'op'                    , valor: 'crudmetodopix'},
                    {parametro: 'idclientesac'          , valor: vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idfilial'              , valor: vself.idfilialselecionada},
                    {parametro: 'registrocrud'          , valor: JSON.stringify(registrocrud)},
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrillpayconfig.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Método de pagamento pix desabilitado com sucesso!', 'Informação!');
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                    vself.mtdcarregadadosfinanceiro();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if (vself.$route.params.idfilial) {
                        vself.idfilialselecionada = vself.$route.params.idfilial;
                    } else {
                        vself.$router.push({name: 'cadfiliais'});
                    }
                    // vself.idfilialselecionada = 1; // retirar isso depois
                    vself.mtdcarregadadosfinanceiro();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.001L', vself.$store.state.perfilusuario)) {
                        vself.mtdselect2_def();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{

        },
        watch:{
            swformapix: function(){
                if(this.swformapix){
                    $('#dadosFormaPix').collapse('show')
                } else {
                    $('#dadosFormaPix').collapse('hide')
                }
            },
            swformacartaocred: function(){
                if(this.swformacartaocred){
                    $('#dadosFormaCartao').collapse('show')
                } else {
                    $('#dadosFormaCartao').collapse('hide')
                }
            },
        }
    }
</script>
<style>
.tooltip-message {
    position: absolute;
    background-color: #343a40;
	color: #fff;
    border: 1px solid #ccc;
    padding: 5px;
    border-radius: 4px;
    box-shadow: 0px 0px 10px rgba(0,0,0,0.1);
    z-index: 1000;
    font-size: 13px;
}
.fade-enter-active, .fade-leave-active {
	transition: opacity .3s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

.def-col-opcoess{
    width: 150px !important;
}
.def-col-cod{
    width: 80px !important;
}
.def-col-ativo{
    width: 200px !important;
}
</style>